import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import isoCountries from "i18n-iso-countries";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { useDymoCheckService, useDymoFetchPrinters } from "react-dymo-hooks";
import { useTranslation } from "react-i18next";
import "react-phone-input-2/lib/style.css";
import { useDispatch } from "react-redux";
import CustomPhone from "../../components/CustomInputs/CustomPhone";
import CustomTextfield from "../../components/CustomInputs/CustomTextfield";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import ProfileContext from "../../components/ProfileContext";
import Toast from "../../components/ToastContainer/CustomToast";
import CustomPhones from "../../Pages/OnBoardV2/CustomPhones";
import { getCompanyById } from "../../slices/Company/CompanySlice";
import { updateStatus } from "../../slices/PinNumber/PinNumberSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";

const Dymo = require("dymojs"),
  dymo = new Dymo();

export default function PinVisitorDetails(props) {
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const { open } = props;
  const dispatch = useDispatch();
  const { setVisitorStatus } = useContext(ProfileContext);
  const companySettings = JSON.parse(localStorage.getItem("companySettings"));
  const [date, setDate] = useState(companySettings.dateFormat);
  const [country, setCountry] = useState("");
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [checkInpayload, setCheckInPayload] = useState({
    pinNumber: props.pinNumber,
    status: "CHECKED_IN",
  });
  const [checkOutpayload, setCheckOutPayload] = useState({
    pinNumber: props.pinNumber,
    status: "CHECKED_OUT",
  });

  if (open) {
    setDiaLogBoxBlur(true);
  }

  const handleClose1 = () => {
    props.handleDialogClose();
    setDiaLogBoxBlur(false);
  };

  const statusDymoService = useDymoCheckService();

  const { statusFetchPrinters, printers } = useDymoFetchPrinters(
    statusDymoService
  );

  const print = (data) => {
    if (!Array.isArray(printers) || printers.length === 0) {
      return;
    }
    printers.forEach((printer) => {
      try {
        dymo.print(printer.name, data);
        console.log(`Print job sent to ${printer.name}`);
      } catch (error) {
        console.error(`Print failed for ${printer.name}:`, error);
      }
    });
  };

  const handleCheckIn = () => {
    setLoading(true);
    if (props.multipleData.status === "CHECKED_OUT") {
      Toast(t("VISITOR_ALREADY_CHECK_OUT"), "error");
      setLoading(false);
      props.handleDialogClose();
      setDiaLogBoxBlur(false);
      return;
    } else if (props.multipleData.status !== "CHECKED_IN") {
      dispatch(updateStatus(checkInpayload))
        .unwrap()
        .then((data) => {
          if (data.code === "CVAI0000") {
            if (data.data.dymoLabel != null) {
              print(data.data.dymoLabel);
            }
            setLoading(false);
            setVisitorStatus(data.data.visit.status);
            Toast(t("VISITOR_CHECK_IN_SUCCESSFULLY"), "success");
            props.handleDialogClose();
            setDiaLogBoxBlur(false);
          } else {
            Toast(data.message, "error");
            setLoading(false);
            props.handleDialogClose();
          }
        });
    } else {
      Toast(t("VISITOR_ALREADY_CHECK_IN"), "error");
      setLoading(false);
      return;
    }
  };

  const handleCheckOut = () => {
    setLoading(true);
    if (props.multipleData.status === "CHECKED_OUT") {
      Toast(t("VISITOR_ALREADY_CHECK_OUT_VISITOR"), "error");
      setLoading(false);
      props.handleDialogClose();
      setDiaLogBoxBlur(false);
    } else if (props.multipleData.status === "CHECKED_IN") {
      dispatch(updateStatus(checkOutpayload))
        .unwrap()
        .then((data) => {
          setLoading(false);
          if (data.code === "CVAI0000") {
            setVisitorStatus(data.data.visit.status);
            Toast(t("VISITOR_CHECK_OUT_SUCCESSFULLY"), "success");
            props.handleDialogClose();
            setDiaLogBoxBlur(false);
          } else {
            Toast(data.message, "error");
            props.handleDialogClose();
            setDiaLogBoxBlur(false);
          }
        });
    } else {
      Toast(t("VISITOR_NOT_CHECK_IN"), "error");
      setLoading(false);
      props.handleDialogClose();
      setDiaLogBoxBlur(false);
    }
  };

  const handleChange = () => {};

  useEffect(() => {
    if (props.data.phone === "" || props.data.phone === null) {
      loadCompany();
    }
  }, [props.data.phone]);

  const loadCompany = () => {
    dispatch(getCompanyById(props.data.companyId))
      .unwrap()
      .then((data) => {
        if ((data.code = "UASI0026")) {
          const fullCountryName = data.data.country;
          const countryCode = getCountryCodeFromName(fullCountryName);
          if (countryCode) {
            setCountry(countryCode);
          } else {
            setCountry("us");
          }
        }
      })
      .catch((er) => {});
  };
  const getCountryCodeFromName = (countryName) => {
    const formattedCountryName = countryName
      .toLowerCase()
      .replace(/\b\w/g, (l) => l.toUpperCase());
    const countryCode = (
      isoCountries.getAlpha2Code(formattedCountryName, "en") || ""
    ).toLowerCase();
    return countryCode || null;
  };

  return (
    <>
      <Dialog
        open={open}
        fullWidth={true}
        disable
        PaperProps={{
          style: {
            borderRadius: "20px !important",
            minWidth: "40vw",
            backgroundColor: darkMode ? "rgb(14, 42, 65)" : "#fff",
            color: darkMode ? "#fff" : "#434547",
          },
        }}
        disableBackdropClick
        disableEscapeKeyDown
        BackdropProps={{
          style: {
            backdropFilter: "blur(5px)",
          },
        }}
      >
        <DialogTitle variant="h4">
          <IconButton
            aria-label="close"
            onClick={handleClose1}
            sx={{
              position: "absolute",
              right: 15,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon onClick={handleClose1} />
          </IconButton>
          <Typography
            style={{
              color: darkMode ? "#fff" : "black",
              fontSize: "20px",
              fontWeight: "450",
            }}
          >
            {t("INVIT002")}
          </Typography>
        </DialogTitle>
        <Divider
          variant="middle"
          style={{
            background: darkMode
              ? "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box"
              : "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box",
            height: "1px",
            opacity: 0.5,
          }}
        />

        <DialogContent style={{ paddingBottom: "0px" }}>
          <Grid
            container
            rowSpacing={2}
            columnSpacing={1}
            justifyContent="center"
            alignItems={"center"}
          >
            <Grid item xs={12} sm={6}>
              <CustomTextfield
                label={t("COMMON020")}
                value={props.data.firstName}
                inputProps={{ maxLength: 50 }}
                handleChange={(e) => handleChange(e)}
                disabled={true}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <CustomTextfield
                label={t("COMMON021")}
                value={props.data.lastName}
                disabled={true}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <CustomTextfield
                label={t("COMMON042")}
                value={props.data.email}
                disabled={true}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              {props.data.phone ? (
                <CustomPhone
                  disabled={true}
                  value={props.data.phone}
                  country={country}
                />
              ) : (
                <CustomPhones
                  disabled={true}
                  value={props.data.phone}
                  country={country}
                />
              )}
            </Grid>

            <Grid item xs={12} sm={6}>
              <CustomTextfield
                label={t("PURPOSE_VISIT")}
                value={props.purposeType?.name}
                InputLabelProps={{ shrink: true }}
                disabled={true}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTextfield
                label={t("COMMON068")}
                value={props.visitorType?.name}
                InputLabelProps={{ shrink: true }}
                disabled={true}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <CustomTextfield
                label={t("VISUPDATE0006")}
                value={props.data.visitorCompanyName}
                InputLabelProps={{ shrink: true }}
                disabled={true}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <CustomTextfield
                label={t("commonsTextFeildHostValue")}
                value={props.host}
                InputLabelProps={{ shrink: true }}
                disabled={true}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTextfield
                label={t("INVITESTARTDATE")}
                value={
                  date === "MM-dd-yyyy"
                    ? moment(
                        CommonUtil.getLocalDateTimeInYearFormat(props.startDate)
                      ).format("MM-DD-YYYY HH:mm")
                    : date === "dd-MM-yyyy"
                    ? moment(
                        CommonUtil.getLocalDateTimeInYearFormat(props.startDate)
                      ).format("DD-MM-YYYY HH:mm")
                    : date === "yyyy-MM-dd"
                    ? moment(
                        CommonUtil.getLocalDateTimeInYearFormat(props.startDate)
                      ).format("YYYY-MM-DD HH:mm")
                    : ""
                }
                InputLabelProps={{ shrink: true }}
                disabled={true}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTextfield
                label={t("INVITESTARTDATEERROR4")}
                value={
                  date === "MM-dd-yyyy"
                    ? moment(
                        CommonUtil.getLocalDateTimeInYearFormat(props.endDate)
                      ).format("MM-DD-YYYY HH:mm")
                    : date === "dd-MM-yyyy"
                    ? moment(
                        CommonUtil.getLocalDateTimeInYearFormat(props.endDate)
                      ).format("DD-MM-YYYY HH:mm")
                    : date === "yyyy-MM-dd"
                    ? moment(
                        CommonUtil.getLocalDateTimeInYearFormat(props.endDate)
                      ).format("YYYY-MM-DD HH:mm")
                    : ""
                }
                InputLabelProps={{ shrink: true }}
                disabled={true}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          style={{
            justifyContent: "center",
          }}
        >
          <CancelButtons
            variant="contained"
            color="secondary"
            onClick={handleCheckOut}
          >
            <Typography variant="body1" style={{ textTransform: "none" }}>
              {t("CHECK_OUT")}
            </Typography>
          </CancelButtons>
          <SubmitButtons variant="contained" onClick={handleCheckIn}>
            <Typography variant="body1" style={{ textTransform: "none" }}>
              {t("CheckIn")}
            </Typography>
          </SubmitButtons>
        </DialogActions>
      </Dialog>
    </>
  );
}
